(function () {
  var CART_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" class="icon icon-cart-custom">' +
    '<path d="M0 0.771429C0 0.566833 0.0812809 0.370617 0.225962 0.225946C0.370643 0.0812752 0.566873 0 0.771482 0H1.34547C2.32268 0 2.909 0.657257 3.24331 1.26823C3.46653 1.67554 3.62802 2.14766 3.75455 2.57554L3.85741 2.57143H16.7134C17.5672 2.57143 18.1844 3.38811 17.9498 4.20994L16.0695 10.8021C15.9009 11.3933 15.5442 11.9136 15.0535 12.284C14.5627 12.6545 13.9646 12.8549 13.3497 12.8551H7.23136C6.6116 12.8551 6.00898 12.6516 5.51613 12.2759C5.02327 11.9001 4.66747 11.3729 4.5034 10.7753L3.72163 7.92412L2.42554 3.55474L2.42451 3.54651C2.26404 2.96331 2.11386 2.41714 1.88962 2.00983C1.67463 1.61383 1.50182 1.54286 1.34649 1.54286H0.771482C0.566873 1.54286 0.370643 1.46158 0.225962 1.31691C0.0812809 1.17224 0 0.976024 0 0.771429ZM5.21831 7.54972L5.99082 10.367C6.14512 10.9245 6.65224 11.3122 7.23136 11.3122H13.3497C13.6292 11.3122 13.9011 11.2212 14.1242 11.0528C14.3473 10.8845 14.5095 10.6481 14.5862 10.3793L16.3729 4.11429H4.20201L5.20391 7.4952L5.21831 7.54972ZM8.74347 15.9429C8.74347 16.4884 8.52672 17.0117 8.1409 17.3975C7.75509 17.7833 7.23181 18 6.68618 18C6.14055 18 5.61728 17.7833 5.23146 17.3975C4.84564 17.0117 4.62889 16.4884 4.62889 15.9429C4.62889 15.3973 4.84564 14.874 5.23146 14.4882C5.61728 14.1024 6.14055 13.8857 6.68618 13.8857C7.23181 13.8857 7.75509 14.1024 8.1409 14.4882C8.52672 14.874 8.74347 15.3973 8.74347 15.9429ZM7.2005 15.9429C7.2005 15.8065 7.14632 15.6756 7.04986 15.5792C6.95341 15.4828 6.82259 15.4286 6.68618 15.4286C6.54977 15.4286 6.41895 15.4828 6.3225 15.5792C6.22605 15.6756 6.17186 15.8065 6.17186 15.9429C6.17186 16.0793 6.22605 16.2101 6.3225 16.3065C6.41895 16.403 6.54977 16.4571 6.68618 16.4571C6.82259 16.4571 6.95341 16.403 7.04986 16.3065C7.14632 16.2101 7.2005 16.0793 7.2005 15.9429ZM15.944 15.9429C15.944 16.4884 15.7272 17.0117 15.3414 17.3975C14.9556 17.7833 14.4323 18 13.8867 18C13.3411 18 12.8178 17.7833 12.432 17.3975C12.0461 17.0117 11.8294 16.4884 11.8294 15.9429C11.8294 15.3973 12.0461 14.874 12.432 14.4882C12.8178 14.1024 13.3411 13.8857 13.8867 13.8857C14.4323 13.8857 14.9556 14.1024 15.3414 14.4882C15.7272 14.874 15.944 15.3973 15.944 15.9429ZM14.401 15.9429C14.401 15.8065 14.3468 15.6756 14.2504 15.5792C14.1539 15.4828 14.0231 15.4286 13.8867 15.4286C13.7503 15.4286 13.6195 15.4828 13.523 15.5792C13.4265 15.6756 13.3724 15.8065 13.3724 15.9429C13.3724 16.0793 13.4265 16.2101 13.523 16.3065C13.6195 16.403 13.7503 16.4571 13.8867 16.4571C14.0231 16.4571 14.1539 16.403 14.2504 16.3065C14.3468 16.2101 14.401 16.0793 14.401 15.9429Z" fill="currentColor"/>' +
    '</svg>';

  var DEALER_LOGIN_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="icon icon-dealer-login">' +
    '<path d="M10.8333 17.5C10.5972 17.5 10.3994 17.42 10.24 17.26C10.0806 17.1 10.0006 16.9022 10 16.6667C9.99945 16.4311 10.0794 16.2333 10.24 16.0733C10.4006 15.9133 10.5983 15.8333 10.8333 15.8333H15.8333V4.16667H10.8333C10.5972 4.16667 10.3994 4.08667 10.24 3.92667C10.0806 3.76667 10.0006 3.56889 10 3.33333C9.99945 3.09778 10.0794 2.9 10.24 2.74C10.4006 2.58 10.5983 2.5 10.8333 2.5H15.8333C16.2917 2.5 16.6842 2.66333 17.0108 2.99C17.3375 3.31667 17.5006 3.70889 17.5 4.16667V15.8333C17.5 16.2917 17.3369 16.6842 17.0108 17.0108C16.6847 17.3375 16.2922 17.5006 15.8333 17.5H10.8333ZM9.3125 10.8333H3.33334C3.09723 10.8333 2.89945 10.7533 2.74 10.5933C2.58056 10.4333 2.50056 10.2356 2.5 10C2.49945 9.76444 2.57945 9.56667 2.74 9.40667C2.90056 9.24667 3.09834 9.16667 3.33334 9.16667H9.3125L7.75 7.60417C7.59723 7.45139 7.52084 7.26389 7.52084 7.04167C7.52084 6.81944 7.59723 6.625 7.75 6.45833C7.90278 6.29167 8.09722 6.20472 8.33334 6.1975C8.56945 6.19028 8.77084 6.27028 8.9375 6.4375L11.9167 9.41667C12.0833 9.58333 12.1667 9.77778 12.1667 10C12.1667 10.2222 12.0833 10.4167 11.9167 10.5833L8.9375 13.5625C8.77084 13.7292 8.57306 13.8092 8.34417 13.8025C8.11528 13.7958 7.91722 13.7089 7.75 13.5417C7.59723 13.375 7.52445 13.1772 7.53167 12.9483C7.53889 12.7194 7.61861 12.5283 7.77084 12.375L9.3125 10.8333Z" fill="white"/>' +
    '</svg>';

  var CAR_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
    '<path d="M9.00684 17C9.00684 17.5304 8.79612 18.0391 8.42105 18.4142C8.04598 18.7893 7.53727 19 7.00684 19C6.4764 19 5.9677 18.7893 5.59262 18.4142C5.21755 18.0391 5.00684 17.5304 5.00684 17C5.00684 16.4696 5.21755 15.9609 5.59262 15.5858C5.9677 15.2107 6.4764 15 7.00684 15C7.53727 15 8.04598 15.2107 8.42105 15.5858C8.79612 15.9609 9.00684 16.4696 9.00684 17ZM19.0068 17C19.0068 17.5304 18.7961 18.0391 18.421 18.4142C18.046 18.7893 17.5373 19 17.0068 19C16.4764 19 15.9677 18.7893 15.5926 18.4142C15.2176 18.0391 15.0068 17.5304 15.0068 17C15.0068 16.4696 15.2176 15.9609 15.5926 15.5858C15.9677 15.2107 16.4764 15 17.0068 15C17.5373 15 18.046 15.2107 18.421 15.5858C18.7961 15.9609 19.0068 16.4696 19.0068 17Z" stroke="#FF9D06" stroke-width="1.5"/>' +
    '<path d="M2.00684 10H18.0068M5.00884 17C2.16684 16.58 2.04684 15.98 2.01084 15.26C1.98684 13.04 2.00684 10.78 2.00684 10C2.22284 8.26 3.16184 6.2 3.64184 5.42M9.00684 10V5M14.9968 17H9.00184M2.02284 5H12.2398C12.2398 5 12.7798 5 13.2598 5.048C14.1588 5.132 14.9138 5.54 15.6698 6.56C16.4698 7.64 17.0848 9.008 17.8998 9.74C19.2548 10.956 21.8328 10.58 21.9768 13.16C22.0128 14.48 22.0128 15.92 21.9528 16.16C21.8568 16.867 21.3118 16.982 20.6338 17C20.0458 17.016 19.3368 16.972 18.9908 17" stroke="#FF9D06" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  var SEARCH_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">' +
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" />' +
    '</svg>';

  var CHECK_CIRCLE_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">' +
    '<path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#22C55E" stroke-width="1.5"/>' +
    '<path d="M6.66667 10L8.88889 12.2222L13.3333 7.77778" stroke="#22C55E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function isCustomerLoggedIn() {
    return document.body.classList.contains('customer-logged-in');
  }

  function upgradeDealerLoginButton(buttonsEl) {
    if (!buttonsEl || buttonsEl.hasAttribute('data-cm-qty-upgraded')) return;

    buttonsEl.setAttribute('data-cm-qty-upgraded', '1');

    var loginUrl = document.body.dataset.accountLoginUrl || '/account/login';
    var link = document.createElement('a');
    link.href = loginUrl;
    link.className = 'button card-dealer-login-button';
    link.innerHTML = DEALER_LOGIN_ICON_SVG + 'Login For Dealer Pricing';

    buttonsEl.innerHTML = '';
    buttonsEl.appendChild(link);
  }

  function interceptCardAddToCart(form) {
    if (!form || form.hasAttribute('data-cm-cart-intercepted')) return;
    form.setAttribute('data-cm-cart-intercepted', '1');

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (!window.routes || !window.fetchConfig || !window.miniCart) {
          form.submit();
          return;
        }

        var submitButton = form.querySelector('.cm-card-cart-btn') || form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        var config = window.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Akshay 10-20 Issue 4: picking a vehicle makes Convermax redraw the card and put its own
        // quantity (1) back in the hidden field, so send what the dealer sees in the box.
        var visibleQty = form.querySelector('.cm-card-qty-input');
        var hiddenQty = form.querySelector('input[name="quantity"]');
        if (visibleQty && hiddenQty) hiddenQty.value = parseInt(visibleQty.value, 10) || 1;

        var formData = new FormData(form);
        formData.append(
          'sections',
          window.miniCart.getSectionsToRender().map(function (section) {
            return section.section;
          })
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        var notice = window.cartStockNotice;
        var variantId = formData.get('id');
        var requested = parseInt(formData.get('quantity'), 10) || 1;
        var beforeQty = notice ? notice.quantityBefore(variantId) : null;
        if (notice) notice.clearNotice(submitButton);

        fetch(window.routes.cart_add_url, config)
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              if (!notice) {
                window.miniCart.updateSectionContents();
                return;
              }
              return notice.settleSingle({
                body: response,
                variantId: variantId,
                requested: requested,
                beforeQty: beforeQty,
                anchor: submitButton,
                opener: submitButton,
              });
            }

            if (notice) {
              notice.clearNotice(submitButton);
              notice.fetchCart();
            }
            window.miniCart.renderContents(response);
            window.miniCart.open(submitButton);

            document.dispatchEvent(
              new CustomEvent('cart:item-add', {
                detail: { items: [response], context: 'collection-card' },
              })
            );
          })
          .catch(function () {})
          .finally(function () {
            if (submitButton) submitButton.disabled = false;
          });
      },
      true
    );
  }

  function upgradeQtyStepper(buttonsEl) {
    if (!buttonsEl || buttonsEl.hasAttribute('data-cm-qty-upgraded')) return;

    if (!isCustomerLoggedIn()) {
      upgradeDealerLoginButton(buttonsEl);
      return;
    }

    var form = buttonsEl.querySelector('.cm_product-item__buttons-form');
    var submitButton = buttonsEl.querySelector('button[type="submit"]');
    var qtyInput = buttonsEl.querySelector('input[name="quantity"]');
    if (!form || !submitButton || !qtyInput) return;

    interceptCardAddToCart(form);

    buttonsEl.setAttribute('data-cm-qty-upgraded', '1');

    var row = document.createElement('div');
    row.className = 'cm-card-qty-row';

    var qtyBox = document.createElement('div');
    qtyBox.className = 'cm-card-qty';

    var minusBtn = document.createElement('button');
    minusBtn.type = 'button';
    minusBtn.className = 'cm-card-qty-btn';
    minusBtn.setAttribute('aria-label', 'Decrease quantity');
    minusBtn.textContent = '−';

    // Akshay Issue 3: a set of four is the default, as on the PDP.
    var DEFAULT_QTY = '4';
    qtyInput.value = DEFAULT_QTY;
    var visibleQtyInput = document.createElement('input');
    visibleQtyInput.type = 'number';
    visibleQtyInput.className = 'cm-card-qty-input';
    visibleQtyInput.value = DEFAULT_QTY;
    visibleQtyInput.min = '1';
    visibleQtyInput.setAttribute('aria-label', 'Quantity');

    var plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.className = 'cm-card-qty-btn';
    plusBtn.setAttribute('aria-label', 'Increase quantity');
    plusBtn.textContent = '+';

    function syncQty(value) {
      var next = parseInt(value, 10);
      if (!next || next < 1) next = 1;
      visibleQtyInput.value = next;
      qtyInput.value = next;
    }

    minusBtn.addEventListener('click', function () {
      syncQty(parseInt(visibleQtyInput.value, 10) - 1);
    });

    plusBtn.addEventListener('click', function () {
      syncQty(parseInt(visibleQtyInput.value, 10) + 1);
    });

    visibleQtyInput.addEventListener('change', function () {
      syncQty(visibleQtyInput.value);
    });

    qtyBox.appendChild(minusBtn);
    qtyBox.appendChild(visibleQtyInput);
    qtyBox.appendChild(plusBtn);

    var cartBtn = document.createElement('button');
    cartBtn.type = 'submit';
    cartBtn.className = 'cm-card-cart-btn';
    cartBtn.setAttribute('aria-label', 'Add to cart');
    cartBtn.innerHTML = CART_ICON_SVG;

    row.appendChild(qtyBox);
    row.appendChild(cartBtn);

    submitButton.replaceWith(row);
  }

  function upgradeAllQtySteppers() {
    document.querySelectorAll('.cm_product-item__buttons').forEach(upgradeQtyStepper);
  }

  var productExtrasCache = {};

  function getProductHandle(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;

    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function fetchProductExtras(handle) {
    if (Object.prototype.hasOwnProperty.call(productExtrasCache, handle)) {
      return productExtrasCache[handle];
    }

    var promise = fetch('/products/' + handle + '?view=classifier')
      .then(function (response) {
        return response.json();
      })
      .catch(function () {
        return null;
      });

    productExtrasCache[handle] = promise;
    return promise;
  }

  function renderUpc(eyebrow, barcode) {
    if (!barcode || !eyebrow.isConnected || eyebrow.querySelector('.cm-card-upc')) return;

    var upc = document.createElement('span');
    upc.className = 'cm-card-upc';
    upc.textContent = 'UPC: ' + barcode;

    var skuContainer = eyebrow.querySelector('.cm_product-item__sku-container');
    if (skuContainer) {
      eyebrow.insertBefore(upc, skuContainer);
    } else {
      eyebrow.appendChild(upc);
    }
  }

  function getOrCreateBadgeWrap(item) {
    var badgeWrap = item.querySelector('.card-type-collection-badges');
    if (badgeWrap) return badgeWrap;

    var mediaContainer = item.querySelector('.cm_product-item__image-container');
    if (!mediaContainer) return null;

    badgeWrap = document.createElement('div');
    badgeWrap.className = 'card-type-collection-badges';
    mediaContainer.insertBefore(badgeWrap, mediaContainer.firstChild);
    return badgeWrap;
  }

  function labelText(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  /* Same rule as snippets/oew-card-labels.liquid. YIQ brightness
     (R*299 + G*587 + B*114) / 1000. 128 or above is #111, otherwise #ffffff. */
  var LABEL_HEX = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
  var LABEL_NEUTRAL = '#ececec';

  function sanitizeHex(value) {
    var text = labelText(value);
    if (!LABEL_HEX.test(text)) return LABEL_NEUTRAL;
    if (text.length === 4) {
      text = '#' + text.charAt(1) + text.charAt(1) + text.charAt(2) + text.charAt(2) + text.charAt(3) + text.charAt(3);
    }
    return text.toLowerCase();
  }

  function contrastText(hex) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    var y = (r * 299 + g * 587 + b * 114) / 1000;
    return y >= 128 ? '#111' : '#ffffff';
  }

  /* custom_card_labels is [{label, color}] from the classifier view.
     Blank labels are skipped. Colour is #rgb or #rrggbb, otherwise the neutral pill. */
  function customLabelsFromExtras(data) {
    var custom = [];
    var raw = data && data.custom_card_labels;
    if (Object.prototype.toString.call(raw) !== '[object Array]') return custom;

    for (var i = 0; i < raw.length && custom.length < 2; i++) {
      var entry = raw[i];
      var text = '';
      var color = '';
      if (entry && typeof entry === 'object') {
        text = labelText(entry.label);
        color = entry.color;
      } else {
        text = labelText(entry);
      }
      if (!text) continue;
      var safe = sanitizeHex(color);
      custom.push({ label: text, color: safe, textColor: contrastText(safe) });
    }
    return custom;
  }

  function renderProductTypeBadge(item, text) {
    var badgeWrap = getOrCreateBadgeWrap(item);
    if (!badgeWrap || badgeWrap.classList.contains('oew-card-labels') || badgeWrap.querySelector('.badge-product-type')) return;

    var badge = document.createElement('span');
    badge.className = 'badge-product-type';
    badge.textContent = text;
    badgeWrap.insertBefore(badge, badgeWrap.firstChild);
  }

  function renderBestSellerBadge(item, title) {
    var badgeWrap = getOrCreateBadgeWrap(item);
    if (!badgeWrap || badgeWrap.classList.contains('oew-card-labels') || badgeWrap.querySelector('.badge-collection-name')) return;

    var badge = document.createElement('span');
    badge.className = 'badge-collection-name';
    badge.textContent = title;
    badgeWrap.appendChild(badge);
  }

  /* Table view hides the thumbnail badge row, so labels move into the
     details column. Grid view keeps them on the image, where today's badges sit. */
  function placeLabelWrap(item) {
    var wrap = item.querySelector('.card-type-collection-badges.oew-card-labels');
    if (!wrap) return;

    var table = document.body.classList.contains('collection-view-list');
    var media = item.querySelector('.cm_product-item__image-container');
    var details = item.querySelector('.cm_product-item__details');
    if (table && details) {
      if (wrap.parentElement !== details) details.insertBefore(wrap, details.firstChild);
    } else if (media && wrap.parentElement !== media) {
      media.insertBefore(wrap, media.firstChild);
    }
  }

  var labelPlacementWatching = false;
  function watchLabelPlacement() {
    if (labelPlacementWatching || !document.body) return;
    labelPlacementWatching = true;
    new MutationObserver(function () {
      document.querySelectorAll('.cm_product-item').forEach(placeLabelWrap);
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function renderOewLabels(item, labels, modifier) {
    var badgeWrap = getOrCreateBadgeWrap(item);
    if (!badgeWrap || badgeWrap.classList.contains('oew-card-labels')) return;

    badgeWrap.classList.add('oew-card-labels');
    var oldBadges = badgeWrap.querySelectorAll('.badge-product-type, .badge-collection-name');
    for (var i = 0; i < oldBadges.length; i++) oldBadges[i].parentNode.removeChild(oldBadges[i]);

    for (var n = 0; n < labels.length; n++) {
      var badge = document.createElement('span');
      badge.className = 'oew-card-label oew-card-label--' + modifier;
      if (modifier === 'custom') {
        badge.textContent = labels[n].label;
        badge.style.backgroundColor = labels[n].color;
        badge.style.color = labels[n].textColor;
      } else {
        badge.textContent = labels[n];
      }
      badgeWrap.appendChild(badge);
    }
    placeLabelWrap(item);
    watchLabelPlacement();
  }

  function upgradeCardEyebrow(item) {
    if (!item || item.hasAttribute('data-cm-eyebrow-upgraded')) return;

    var details = item.querySelector('.cm_product-item__details');
    var vendor = item.querySelector('.cm_product-item__vendor');
    var skuContainer = item.querySelector('.cm_product-item__sku-container');
    if (!details || (!vendor && !skuContainer)) return;

    item.setAttribute('data-cm-eyebrow-upgraded', '1');

    var eyebrow = document.createElement('div');
    eyebrow.className = 'cm-card-eyebrow';
    if (vendor) eyebrow.appendChild(vendor);
    if (skuContainer) eyebrow.appendChild(skuContainer);

    details.insertBefore(eyebrow, details.firstChild);
  }

  function upgradeCardFooter(item) {
    if (!item || item.hasAttribute('data-cm-footer-upgraded')) return;

    var prices = item.querySelectorAll('.cm_product-item__price');
    var buttons = item.querySelector('.cm_product-item__buttons');
    if (!prices.length || !buttons) return;

    item.setAttribute('data-cm-footer-upgraded', '1');

    var priceContainer = prices[0].parentElement;

    var footer = document.createElement('div');
    footer.className = 'cm-card-footer';

    if (isCustomerLoggedIn()) {
      var priceRow = document.createElement('div');
      priceRow.className = 'cm-card-price-row';
      prices.forEach(function (price) {
        priceRow.appendChild(price);
      });
      footer.appendChild(priceRow);
    } else {
      prices.forEach(function (price) {
        price.remove();
      });
    }

    footer.appendChild(buttons);

    item.appendChild(footer);

    if (
      priceContainer &&
      priceContainer !== item &&
      priceContainer.classList.contains('cm_product-item__price-container') &&
      !priceContainer.hasChildNodes()
    ) {
      priceContainer.remove();
    }
  }

  function upgradeAllCardFooters() {
    document.querySelectorAll('.cm_product-item').forEach(upgradeCardFooter);
  }

  function hidePricesIfLoggedOut() {
    if (isCustomerLoggedIn()) return;

    document.querySelectorAll('.cm_product-item__price').forEach(function (price) {
      var priceContainer = price.parentElement;
      price.remove();

      if (
        priceContainer &&
        priceContainer.classList.contains('cm_product-item__price-container') &&
        !priceContainer.hasChildNodes()
      ) {
        priceContainer.remove();
      }
    });
  }

  function renderCardSpecs(item, specs) {
    var details = item.querySelector('.cm_product-item__details');
    if (!details || details.querySelector('.card-specs')) return;

    var entries = [
      { label: 'Size', value: specs.size },
      { label: 'Bolt Pattern', value: specs.bolt_pattern },
      { label: 'Finish', value: specs.finish },
      { label: 'Offset', value: specs.offset },
    ].filter(function (entry) {
      return entry.value;
    });

    if (!entries.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'card-specs';

    entries.forEach(function (entry) {
      var spec = document.createElement('div');
      spec.className = 'card-spec';

      var label = document.createElement('span');
      label.className = 'card-spec-label';
      label.textContent = entry.label;

      var value = document.createElement('span');
      value.className = 'card-spec-value';
      value.textContent = entry.value;

      spec.appendChild(label);
      spec.appendChild(value);
      wrap.appendChild(spec);
    });

    details.appendChild(wrap);
  }

  /* null when the warehouse metafield is missing. 0 is a real count (Out). */
  function readStockQty(value) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'object') {
      if (value && Object.prototype.hasOwnProperty.call(value, 'value')) return readStockQty(value.value);
      return null;
    }
    var n = typeof value === 'number' ? value : parseInt(String(value).replace(/,/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  function buildStockRow(label, qty) {
    var known = typeof qty === 'number' && !isNaN(qty);
    var inStock = known && qty > 0;
    var row = document.createElement('span');
    row.className = 'cm-card-stock-row ' + (!known ? 'is-unknown' : inStock ? 'is-in' : 'is-out');

    var dot = document.createElement('span');
    dot.className = 'cm-card-stock-dot';

    var txt = document.createElement('span');
    txt.className = 'cm-card-stock-text';
    txt.textContent = known
      ? (inStock ? 'In Stock (' + label + ')' : 'Out of Stock (' + label + ')')
      : label;

    row.appendChild(dot);
    row.appendChild(txt);

    if (inStock) {
      var count = document.createElement('span');
      count.className = 'cm-card-stock-qty';
      count.textContent = String(qty);
      row.appendChild(count);
    } else if (!known) {
      /* Keep the FL/TX cell the same width as a quantity. Never the origins sentence. */
      var dash = document.createElement('span');
      dash.className = 'cm-card-stock-qty is-unknown-label';
      dash.textContent = '—';
      row.appendChild(dash);
    }

    return row;
  }

  /* Retail (MAP) price on a PLP card, so Retail Mode has something to show.
     The figure arrives pre-formatted from the classifier view — the card JS
     must never format currency itself. The price row only exists for a
     signed-in dealer, which is also the only time a price mode applies. */
  function renderRetailPrice(item, retail) {
    if (!retail) return;

    var row = item.querySelector('.cm-card-price-row');
    if (!row || row.querySelector('.b2b-retail-price')) return;

    var wrap = document.createElement('span');
    wrap.className = 'b2b-retail-price';

    var label = document.createElement('span');
    label.className = 'b2b-retail-price-label';
    label.textContent = 'Retail';

    var amount = document.createElement('span');
    amount.className = 'b2b-retail-price-amount';
    amount.textContent = retail;

    wrap.appendChild(label);
    wrap.appendChild(amount);
    row.appendChild(wrap);
  }

  function renderStockStatus(item, inv) {
    if (!inv) return;

    var host = item.querySelector('.cm-card-footer') || item.querySelector('.cm_product-item__details');
    if (!host || item.querySelector('.cm-card-stock')) return;

    var wrap = document.createElement('div');
    wrap.className = 'cm-card-stock';

    /* Always two warehouse cells. A "Ships from Florida, Texas" sentence in
       this slot has no grid column, so it blew the table row out. Missing
       metafields render an em dash, not a guessed quantity. */
    wrap.appendChild(buildStockRow('Florida', readStockQty(inv.stock_florida)));
    wrap.appendChild(buildStockRow('Texas', readStockQty(inv.stock_texas)));

    host.insertBefore(wrap, host.firstChild);
  }

  function upgradeCardExtras(item) {
    if (!item || item.hasAttribute('data-cm-extras-upgraded')) return;

    var handle = getProductHandle(item);
    if (!handle) return;

    item.setAttribute('data-cm-extras-upgraded', '1');

    fetchProductExtras(handle).then(function (data) {
      if (!data) return;

      /* PLP redesign (plp-redesign.js) reads the same payload for the
         style eyebrow, the "Fits" chip and the table view. */
      item.__cmExtras = data;
      if (data.style) item.setAttribute('data-cm-style', data.style);
      item.dispatchEvent(new CustomEvent('cm:extras', { detail: data }));

      var eyebrow = item.querySelector('.cm-card-eyebrow');
      if (eyebrow) renderUpc(eyebrow, data.barcode);

      var saleLabel = labelText(data && data.sale_label);
      var customLabels = customLabelsFromExtras(data);
      if (saleLabel) {
        renderOewLabels(item, [saleLabel], 'sale');
      } else if (customLabels.length) {
        renderOewLabels(item, customLabels, 'custom');
      } else {
        if (data.classifier === 'Single') {
          renderProductTypeBadge(item, data.classifier);
        }

        if (data.is_best_seller && data.best_seller_title) {
          renderBestSellerBadge(item, data.best_seller_title);
        }
      }

      if (data.specs) renderCardSpecs(item, data.specs);

      if (data.retail_price) renderRetailPrice(item, data.retail_price);
      if (data.inventory) renderStockStatus(item, data.inventory);
    });
  }

  function upgradeAllCardExtras() {
    document.querySelectorAll('.cm_product-item').forEach(upgradeCardExtras);
  }

  function upgradeAllCardEyebrows() {
    document.querySelectorAll('.cm_product-item').forEach(upgradeCardEyebrow);
  }

  function parseVehicleFromUrl() {
    var raw = window.location.search.replace(/^\?/, '').split('&')[0];
    if (!raw) return null;

    /* /pages/search encodes the slashes (?Fitment%2FVehicle-Specific%2FYear%2F2017…); decode first (mobile QA M21). */
    try { raw = decodeURIComponent(raw); } catch (e) {}
    var segments = raw.split('/');
    var vehicle = {};

    segments.forEach(function (segment, index) {
      if (segment === 'Year') vehicle.year = segments[index + 1];
      if (segment === 'Make') vehicle.make = segments[index + 1];
      if (segment === 'Model') vehicle.model = segments[index + 1];
    });

    if (!vehicle.year || !vehicle.make || !vehicle.model) return null;
    return vehicle;
  }

  function insertVehicleBanner() {
    var searchHeader = document.querySelector('.cm_SearchHeader');
    if (!searchHeader || !searchHeader.parentElement || document.querySelector('.cm-vehicle-banner')) return;

    var vehicle = parseVehicleFromUrl();

    var banner = document.createElement('div');
    banner.className = 'cm-vehicle-banner';
    if (vehicle) banner.classList.add('cm-vehicle-banner-confirmed');

    banner.innerHTML =
      '<div class="cm-vehicle-banner-select-state">' +
      '<span class="cm-vehicle-banner-icon">' +
      CAR_ICON_SVG +
      '</span>' +
      '<span class="cm-vehicle-banner-text">Select your vehicle to view compatible products</span>' +
      '<form class="cm-vehicle-banner-form is-active" action="" method="get">' +
      '<div class="cm-vehicle-banner-fields">' +
      '<div class="form-group">' +
      '<select class="dropdown-filter" data-index="1" aria-label="Year">' +
      '<option class="default" value="" selected disabled>Year</option>' +
      '</select>' +
      '</div>' +
      '<div class="form-group disabled">' +
      '<select class="dropdown-filter" data-index="2" aria-label="Make" disabled>' +
      '<option class="default" value="" selected disabled>Make</option>' +
      '</select>' +
      '</div>' +
      '<div class="form-group disabled">' +
      '<select class="dropdown-filter" data-index="3" aria-label="Model" disabled>' +
      '<option class="default" value="" selected disabled>Model</option>' +
      '</select>' +
      '</div>' +
      '</div>' +
      '<button type="submit" disabled class="cm-vehicle-banner-submit" aria-label="Find Products">' +
      SEARCH_ICON_SVG +
      '<span>Find Products</span>' +
      '</button>' +
      '</form>' +
      '</div>' +
      '<div class="cm-vehicle-banner-confirm-state">' +
      '<span class="cm-vehicle-banner-confirm-icon">' +
      CHECK_CIRCLE_ICON_SVG +
      '</span>' +
      '<span class="cm-vehicle-banner-confirm-text">Showing wheels that fit your <strong>' +
      (vehicle ? (vehicle.year + ' ' + vehicle.make + ' ' + String(vehicle.model).replace(/-/g, ' ')) : '') +
      '</strong></span>' +
      '<button type="button" class="cm-vehicle-banner-change">Change</button>' +
      '</div>';

    searchHeader.parentElement.insertBefore(banner, searchHeader);

    /* Vehicle searches land on /pages/search titled just "Search" (mobile QA M21). */
    if (vehicle && /\/pages\/search/.test(window.location.pathname)) {
      var h1 = document.querySelector('main h1, h1');
      if (h1 && /^\s*search\s*$/i.test(h1.textContent)) {
        h1.textContent = 'Wheels for ' + vehicle.year + ' ' + vehicle.make + ' ' + String(vehicle.model).replace(/-/g, ' ');
      }
    }

    var changeButton = banner.querySelector('.cm-vehicle-banner-change');
    if (changeButton) {
      changeButton.addEventListener('click', function () {
        banner.classList.remove('cm-vehicle-banner-confirmed');
      });
    }

    if (window.cmInitVehiclePanel) {
      window.cmInitVehiclePanel(banner.querySelector('.cm-vehicle-banner-form'));
    }
  }

  function insertViewToggle() {
    var header = document.querySelector('.cm_SearchHeader');
    if (!header || header.querySelector('collection-view-toggle')) return;

    var toggle = document.createElement('collection-view-toggle');
    toggle.className = 'collection-view-toggle';
    toggle.innerHTML =
      '<button type="button" class="collection-view-toggle-btn" data-view="grid" aria-label="Grid view" aria-pressed="false">' +
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<rect x="1" y="1" width="6.5" height="6.5" rx="1" fill="currentColor"/>' +
      '<rect x="10.5" y="1" width="6.5" height="6.5" rx="1" fill="currentColor"/>' +
      '<rect x="1" y="10.5" width="6.5" height="6.5" rx="1" fill="currentColor"/>' +
      '<rect x="10.5" y="10.5" width="6.5" height="6.5" rx="1" fill="currentColor"/>' +
      '</svg><span>Grid</span></button>' +
      '<button type="button" class="collection-view-toggle-btn" data-view="list" aria-label="List view" aria-pressed="false">' +
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<rect x="1" y="2" width="16" height="3" rx="1" fill="currentColor"/>' +
      '<rect x="1" y="7.5" width="16" height="3" rx="1" fill="currentColor"/>' +
      '<rect x="1" y="13" width="16" height="3" rx="1" fill="currentColor"/>' +
      '</svg><span>List</span></button>';

    header.appendChild(toggle);
  }

  function insertFacetHeading() {
    var panel = document.querySelector('.cm_FacetPanel');
    if (!panel || panel.querySelector('.sidebar-filter-heading')) return;

    var heading = document.createElement('div');
    heading.className = 'sidebar-filter-heading';
    heading.innerHTML = '<h3 class="sidebar-filter-heading-title">Filter by</h3>';

    panel.insertBefore(heading, panel.firstChild);
  }

  /* autoCheckInStock removed 2026-08-04: it force-selected the "In-stock Only"
     facet on every collection load, so the header "Products" link could never
     land unfiltered. Dealers who want the filter click it in the sidebar. */

  function renameInStockLabel() {
    var label = document.querySelector(
      '.cm_field-stock .cmRepeater_ShowAlwaysValues .facetdiv:first-child .facetentrykey'
    );
    if (!label || label.textContent.trim() !== 'In-stock Only') return;

    label.textContent = 'In Stock';
  }

  function renameInStockChip() {
    document.querySelectorAll('.cm_FilterChips .facetentrykey').forEach(function (chip) {
      Array.prototype.forEach.call(chip.childNodes, function (node) {
        if (node.nodeType === 3 && node.nodeValue.indexOf('In-stock Only') !== -1) {
          node.nodeValue = node.nodeValue.replace('In-stock Only', 'In Stock');
        }
      });
    });
  }

  function renameTotalHitsLabel() {
    var totalHits = document.querySelector('.cm_total-hits');
    if (!totalHits || totalHits.querySelector('.cm-total-hits-prefix')) return;

    var prefix = document.createElement('span');
    prefix.className = 'cm-total-hits-prefix';
    prefix.textContent = 'Showing ';
    totalHits.insertBefore(prefix, totalHits.firstChild);
  }

  function safeRun(fn) {
    try {
      fn();
    } catch (e) {}
  }

  function run() {
    safeRun(insertVehicleBanner);
    safeRun(insertViewToggle);
    safeRun(insertFacetHeading);
    safeRun(renameInStockLabel);
    safeRun(renameInStockChip);
    safeRun(renameTotalHitsLabel);
    safeRun(upgradeAllCardEyebrows);
    safeRun(upgradeAllCardFooters);
    safeRun(hidePricesIfLoggedOut);
    safeRun(upgradeAllCardExtras);
    safeRun(upgradeAllQtySteppers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function () {
    run();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

/* Mobile QA 2026-10-14 (M14): Convermax facet titles are plain divs. Expose them as
   toggle buttons with the open/closed state (collapsed groups carry cm_icon-angle.left). */
(function () {
  function syncFacetTitles() {
    var titles = document.querySelectorAll('.cm_FacetPanel .facettitle');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      if (t.getAttribute('role') !== 'button') t.setAttribute('role', 'button');
      var expanded = t.querySelector('.cm_icon-angle.left') ? 'false' : 'true';
      if (t.getAttribute('aria-expanded') !== expanded) t.setAttribute('aria-expanded', expanded);
    }
  }
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; syncFacetTitles(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('DOMContentLoaded', syncFacetTitles);
})();

/* Mobile QA 2026-10-14 (M3): Convermax indexes most accessories as "No Fitment Data", so with a
   saved vehicle a collection like Accessories returns nothing ("No results found. Click here to
   reset your search."). Until Convermax treats them as universal, say why and make "show all"
   the obvious action. The link is Convermax's own reset. */
(function () {
  function explain() {
    if (!/^\/collections\//.test(window.location.pathname)) return;
    var link = document.querySelector('.cm_SearchPage .cm_message-link, .cm_message-link');
    if (!link) return;
    var box = link.parentElement;
    if (!box || box.getAttribute('data-oew-empty') === '1') return;
    box.setAttribute('data-oew-empty', '1');
    box.classList.add('oew-empty-results');
    var p = document.createElement('p');
    p.className = 'oew-empty-results__text';
    p.textContent = "Nothing here is listed for your saved vehicle. Most accessories (lug nuts, TPMS sensors, caps) fit any vehicle — show everything in this collection.";
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button oew-empty-results__btn';
    btn.textContent = 'Show all items';
    btn.addEventListener('click', function () { link.click(); });
    box.textContent = '';
    box.appendChild(p);
    box.appendChild(btn);
    box.appendChild(link);
    link.hidden = true;
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; explain(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
